import { useSubscriptionContext } from '../../../contexts/SubscriptionContext';
import { useUserContext } from '../../../contexts/UserContext';
import { formatDate, getDaysUntil } from '../../../utils/subscriptionUtils';
import { Btn } from '../../ui';

export const PastDueBanner = () => {
    const { accountStatus } = useSubscriptionContext();
    const { company } = useUserContext();

    if (accountStatus !== 'past-due') return null;

    const companyData = company as Record<string, unknown> | null;
    const gracePeriodEndDate = companyData?.gracePeriodEndDate as string | null;
    const paymentFailedAt = companyData?.paymentFailedAt as string | null;

    const daysLeft = gracePeriodEndDate ? getDaysUntil(gracePeriodEndDate) : 0;

    return (
        <div className="past-due-banner">
            <div className="past-due-banner-content">
                <span className="past-due-banner-icon">🚨</span>
                <div className="past-due-banner-text">
                    <strong>Payment failed — Action required</strong>
                    <span className="past-due-banner-subtext">
                        Your charge was declined{paymentFailedAt ? ` on ${formatDate(paymentFailedAt)}` : ''}.
                        Your Core Program and add-ons will remain active for {daysLeft} more day{daysLeft !== 1 ? 's' : ''}.
                        Update your payment method to avoid service interruption.
                    </span>
                </div>
            </div>
            <div className="past-due-banner-actions">
                <span className="past-due-banner-countdown">{daysLeft} DAYS LEFT</span>
                <Btn
                    variant="primary"
                    buttonSize="sm"
                    buttonText="Update Payment →"
                    buttonOnClick={() => {/* TODO: open UpdatePaymentModal */ }}
                />
            </div>
        </div>
    );
};
